<template>
    <section class="section">
        <div class="container">
            <div class="level">
                <div class="level-left">
                    <h1 class="title is-4">Brugere</h1>
                </div>
                <div class="level-right">
                    <button class="button is-primary" @click="openModal(false)">Opret</button>
                </div>
            </div>
            <list
                table-classes="table is-fullwidth"
                :columns="columns"
                :data="listUsers"
                @rowClicked="(row) => openModal(row.id)"
            />

        </div>
        <modal
            :active="modalOpen"
            :user-id="modalUserId"
            @closed="closeModal"
        />
    </section>
</template>

<script>
import List from '@elems/list'
import Modal from './users/Modal'
import { mapGetters } from 'vuex'

export default {
    components: {
        List,
        Modal,
    },

    data() {
        return {
            columns: [
                { name: 'name', title: 'Navn', sortable: true, searchable: true, },
                { name: 'initials', title: 'Initialer', sortable: true, searchable: true, },
                { name: 'email', title: 'E-mail', sortable: true, searchable: true, },
                { name: 'role', title: 'Rolle', sortable: true, searchable: true, },
            ],
            modalOpen: false,
            modalUserId: false,
        }
    },

    created() {
        this.$store.dispatch('loadUsers')
    },

    computed: {
        ...mapGetters([
            'listUsers',
        ]),
    },

    methods: {
        openModal(userId = null) {
            this.modalOpen = true
            this.modalUserId = userId
        },
        closeModal() {
            this.modalOpen = false
            this.modalUserId = false
        }
    }
}
</script>

<style>

</style>
